import { render } from "./Notifications.vue?vue&type=template&id=5464d7e2&scoped=true"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"

import "./Notifications.vue?vue&type=style&index=0&id=5464d7e2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5464d7e2"

export default script